/** Evidence intake — overview + canonical fact sub-pages. */

export const EVIDENCE_FLOWS = [
  { id: "overview", label: "Overview" },
  { id: "discovery", label: "Discovery" },
  { id: "quality", label: "Quality" },
  { id: "facts", label: "Facts" },
  { id: "sources", label: "Sources" },
];

export const EVIDENCE_DRILL = EVIDENCE_FLOWS.filter((f) => f.id !== "overview");

export const EVIDENCE_FOCUS_DETAIL = {
  overview: "Discovery, quality metrics and canonical facts — one screen each.",
  discovery: "Minimum sufficient evidence and passport enrichment.",
  quality: "State counts — UNKNOWN is never coerced.",
  facts: "Canonical ledger with provenance.",
  sources: "Connectors and intake channels.",
};
